<template>
<div>
    <div class="list-entity d-flex gap-2 justify-content-start align-items-center px-2" v-if="!selectedUserForTrainingSummary?.moduleDetails">
        <loader-component></loader-component>
    </div>
    <div class="p-2">
        <div class="list-entity d-flex gap-2 justify-content-start align-items-center px-2">
            <img
                :src="(selectedUserForTrainingSummary.user && selectedUserForTrainingSummary.user.profileImg) || `https://avatars.dicebear.com/api/initials/${(selectedUserForTrainingSummary.user.name)}.svg?scale=101&fontSize=36`"
                alt=""
                class="profile-img"
            />
            <div>
                <p class="qb-entity-title m-0">
                    {{ selectedUserForTrainingSummary.user && selectedUserForTrainingSummary.user.name }}
                </p>
                <p class="qb-entity-subtitle">
                    {{ selectedUserForTrainingSummary.user && selectedUserForTrainingSummary.user.designation }}
                </p>
            </div>
        </div>
        <hr class="divider border my-2" />
        <div class="d-flex tab-container gap-2 p-2">
            <div :class="[activetab == '' ? 'active' : '', 'tab']" @click="getTraining('')">All</div>
            <div :class="[activetab == 'COMPLETED' ? 'active' : '', 'tab']" @click="getTraining('COMPLETED')">
                Completed
            </div>
            <div :class="[activetab == 'IN_PROGRESS' ? 'active' : '', 'tab']" @click="getTraining('IN_PROGRESS')">
                In Progress
            </div>
            <div
                :class="[activetab == 'NOT_YET_STARTED' ? 'active' : '', 'tab']"
                @click="getTraining('NOT_YET_STARTED')"
            >
                Not Yet Started
            </div>
        </div>
        <div
            v-if="
                selectedUserForTrainingSummary.moduleDetails && selectedUserForTrainingSummary.moduleDetails.length == 0
            "
            class="my-3"
        >
            <p class="text-center">No Data Found</p>
        </div>
        <div class="row m-0">
            <ReporteeWorkSheetCardComponent
                v-for="(data, index) in selectedUserForTrainingSummary.moduleDetails"
                class="col-4 mb-3 px-2"
                :key="index"
                :moduleData="data"
                @setActiveTraining="setActiveTraining(data)"
            />
        </div>
        <div class="m-2">
            <Pagination :totalRecords="selectedUserForTrainingSummary?.totalElements" :pageSize="6" @pageChange="pageChange" />
        </div>
        <Drawer @close="toggleDrawer" :align="align" :closeable="true" :maskClosable="true">
            <div v-if="openDrawer" class="drawer-content">
                <!-- <h1 v-for="(data, index) in 50" :key="index">OPened</h1> -->
                <Button label="Close" class="qb-btn qb-btn-outline-sm ms-2" @onClick="toggleDrawer" />

                <div class="row">
                    <div class="col-8">
                        <div class="p-3">
                            <div class="d-flex mt-2 align-items-center">
                                <div>
                                    <img :src="activeTraining.trainingImg" alt="" class="qb-avatar me-2" v-if="activeTraining.trainingImg"/>
                                    <img v-else src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU" class="training-img me-2"/>
                                </div>
                                <div>
                                    <p class="title-text my-0">{{ activeTraining.name }}</p>
                                </div>
                            </div>
                            <div class="col-3 align-items-center mt-3">
                                <div class="progress-outer-bar">
                                    <div
                                        class="progress-inner-bar"
                                        :style="{
                                            width:
                                                getPercentage(
                                                    activeTraining.totalNoOfTasks,
                                                    activeTraining.completedTasks
                                                ) + '%',
                                        }"
                                    ></div>
                                </div>
                                <span class="percentage-text">{{
                                    getPercentage(activeTraining.totalNoOfTasks, activeTraining.completedTasks) +
                                    '% Completed'
                                }}</span>
                            </div>
                            <div class="worksheet-scroll mt-2">
                                <div class="p-2">
                                    <p class="my-1 ms-2 sub-heading">Description</p>
                                    <div class="my-1 p-2 title-sub-text" v-html="worksheet.description"></div>

                                    <div class="mt-4">
                                        <p class="my-0 ms-2 sub-heading">Training Content</p>
                                        <div class="p-3">
                                            <div v-for="(day, index) in worksheet.worksheet" :key="index">
                                                <p class="task-detail-module-identifier my-3">
                                                    <font-awesome-icon icon="fa-solid fa-cube" /> DAY {{ index + 1 }} -
                                                    {{ day.status.replaceAll('_', ' ') }}
                                                </p>
                                                <div class="timeline-box">
                                                    <TaskProgressListComponent
                                                        :dayTask="dayTask"
                                                        :index="index"
                                                        :lastIndex="lastIndex"
                                                        v-for="(dayTask, index) in day.taskList"
                                                        :key="index"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div>
                            <p class="my-3 sub-heading">Training Comments</p>
                            <div class="comment-section">
                                <div class="comment-box">
                                    <div class="comment-body">
                                        <div v-for="(data, index) in commentsForSelectedWorksheet" :key="index">
                                            <div
                                                :class="[
                                                    'single-chat',
                                                    data.userId !== user.userId ? 'chat-right' : 'chat-left',
                                                ]"
                                            >
                                                <div class="p-2">
                                                    <p class="title-text my-0">
                                                        {{ data.userName }}
                                                    </p>
                                                    <p class="title-sub-text my-0">{{ data.comment }}</p>
                                                </div>
                                                <div class="comment-footer py-1 px-2">
                                                    <p class="comment-date my-0">{{ formatDate(data.date) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="message-bar d-flex align-items-center">
                                        <Input placeholder="Type your comment" type="text" v-model="message" />
                                        <Button
                                            label="Send"
                                            class="qb-btn qb-btn-primary-md ms-2"
                                            @onClick="sendMessage"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>
    </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Drawer from 'vue-simple-drawer';
import Pagination from "../components/PaginationComponent.vue"
import Button from '../components//ButtonComponent.vue';
import Input from '../components/TextFieldComponent.vue';
import ReporteeWorkSheetCardComponent from '../components/ReporteeWorkSheetCardComponent.vue';
import LoaderComponent from "../components/LoaderComponent.vue"
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers('Training');
const { mapActions: workSheetMapActions, mapGetters: workSheetMapGetters } = createNamespacedHelpers('WorkSheet');
const { mapGetters: authMapGetters } = createNamespacedHelpers('Auth');
import TaskProgressListComponent from '../components/TaskProgressListComponent.vue';

export default {
    name: 'ReporteeTrainingDetailPage',
    data() {
        return {
            align: 'right',
            openDrawer: false,
            activeTraining: null,
            message: '',
            activetab: '',
        };
    },
    components: {
        ReporteeWorkSheetCardComponent,
        Drawer,
        Input,
        Button,
        TaskProgressListComponent,
        Pagination,
        LoaderComponent
    },
    computed: {
        ...trainingMapGetters({
            selectedUserForTrainingSummary: 'getSelectedUserForTrainingSummary',
            commentsForSelectedWorksheet: 'getCommentsForSelectedWorkSheet',
        }),
        ...workSheetMapGetters({
            worksheet: 'getWorkSheet',
        }),
        ...authMapGetters({
            user: 'getUser',
        }),
    },
    methods: {
        ...trainingMapActions({
            getCommentsByWorksheetId: 'GET_COMMENTS_BY_WORKSHEET_ID',
            getEnrolledTrainingsByUserId: 'GET_WORKSHEETS_BY_USER_ID',
        }),
        ...workSheetMapActions({
            getWorkSheetDetails: 'GET_WORKSHEET_BY_ID',
            // getEnrolledTrainingList: "GET_ENROLLED_TRAININGS_BY_USER_ID",
            createNewComment: 'CREATE_COMMENT_FOR_WORKSHEET',
        }),
        getTraining(status) {
            this.activetab = status;
            this.getEnrolledTrainingsByUserId({ userId: this.selectedUserForTrainingSummary.user.id, status });
        },
        setActiveTraining(training) {
            this.activeTraining = training;
            this.getWorkSheetDetails(training.id);
            this.getCommentsByWorksheetId(training.id);
            this.toggleDrawer();
        },
        toggleDrawer() {
            this.openDrawer = !this.openDrawer;
            if (!this.openDrawer) {
                this.activeTraining = null;
            }
        },
        pageChange(page) {
            // this.getEnrolledTrainingsByUserId({ userId: this.selectedUserForTrainingSummary.user.id, status });
      this.getEnrolledTrainingsByUserId({userId: this.selectedUserForTrainingSummary.user.id, page ,status:this.activetab});
    },
        sendMessage() {
            const payload = {
                comment: this.message,
                userId: this.user.userId,
                worksheetId: this.activeTraining.id,
            };

            this.createNewComment({
                payload,
                successCallback: ({ data }) => {
                    if (data.status === 'OK') {
                        Vue.$toast.success('Comment Posted Successfully');
                        this.getCommentsByWorksheetId(this.activeTraining.id);
                    } else {
                        Vue.$toast.error('Something went wrong');
                    }
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
            this.message = '';
        },
        structureData(data) {
            return data.replaceAll('_', ' ');
        },
        getPercentage(totalTask, completedTask) {
            return [
                isNaN(Number(Math.round((completedTask / totalTask) * 100)))
                    ? 0
                    : Number(Math.round((completedTask / totalTask) * 100)),
            ];
        },
    },
    watch: {
        $route() {
            this.activetab = '';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.profile-img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.title-text {
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    color: $dark-300;
}

.task-detail-module-identifier {
    font-size: $font-size-sm;
    color: $light-600;
    font-weight: $font-weight-bold;
    margin: 0px;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.sub-heading {
    font-size: $font-size-lg;
    color: $dark-300;
    font-weight: 600;
}

.qb-entity-title {
    color: $dark-200;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-2;
    margin: 0px;
}

.qb-entity-subtitle {
    color: $light-500;
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}
.comment-footer {
    background-color: $light-100;
}

.drawer-content {
    margin-top: 40px;
}

.title-sub-text {
    font-size: $font-size-md;
    color: $dark-200;
}
.timeline-box {
    border-left: 1px solid $dark-200;
    padding-left: 10px;
    margin-left: 10px;
}

.qb-avatar {
    width: 75px;
    height: 40px;
    border-radius: 5px;
}

.progress-outer-bar {
    width: 100%;
    height: 10px;
    background-color: $light-200;
    border-radius: 5px;
}

.worksheet-scroll {
    max-height: 550px;
    overflow: auto;
    border: 1px solid $light-200;
}

.progress-inner-bar {
    height: 100%;
    background-color: $primary-100;
    border-radius: 5px;
}

.date-text {
    font-size: $font-size-sm;
    color: $dark-200;
}

.comment-date {
    font-size: $font-size-xs;
    color: $dark-200;
}

.percentage-text {
    font-size: $font-size-sm;
    font-weight: $font-weight-bold;
    color: $dark-300;
}

.comment-body {
    border: 1px solid $light-200;
    border-radius: 5px;
    height: 500px;
    overflow-y: auto;
    padding: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
}

.single-chat {
    border: 1px solid $light-200;
    border-radius: 5px;
    // padding: 10px;
    margin-bottom: 15px;
    min-width: 250px;
    max-width: 300px;
}

.chat-right {
    float: left;
}

.chat-left {
    float: right;
}

.training-img {
    width: 60px;
    height: 35px;
    border-radius: 5px;
}
.tab {
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-2;
    width: fit-content;
    border-radius: $field-border-radius-high;
    padding: 3px 10px;
    text-decoration: none;
    background-color: $light-300;
    color: $dark-300;
}

.tab:hover {
    cursor: pointer;
}
.active {
    color: $light-300;
    background-color: $dark-300;
}
</style>
